export const platformOptions = ["APPLE", "GOOGLE"] as const;

export const challengeTypeOptions = ["COUNTER", "STREAK"] as const;

// `users.role` is free text server-side (`text('role').notNull().default('default')`),
// not a pg enum, so this list is a UI convention rather than the schema's truth.
// Only 'admin' is load-bearing — AdminGuard/RolesGuard match that exact string and
// it is what lets an account reach this panel at all; 'default' is the column
// default and means "ordinary user". A row carrying anything else is still valid,
// so the edit form offers the stored value alongside these rather than coercing it.
export const userRoleOptions = ["default", "admin"] as const;

export type PlatformOption = (typeof platformOptions)[number];
export type ChallengeTypeOption = (typeof challengeTypeOptions)[number];
export type UserRoleOption = (typeof userRoleOptions)[number];
